import React from 'react'

export const DetalleContratoyFormularios = () => {
  return (
    <div>DetalleContratoyFormularios</div>
  )
}
